import { render, staticRenderFns } from "./BuilderWorkspace.vue?vue&type=template&id=5ff787da&scoped=true"
import script from "./BuilderWorkspace.vue?vue&type=script&lang=js"
export * from "./BuilderWorkspace.vue?vue&type=script&lang=js"
import style0 from "./BuilderWorkspace.vue?vue&type=style&index=0&id=5ff787da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff787da",
  null
  
)

export default component.exports